import { useTranslation } from "react-i18next";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { monoInk } from "../../lib/mono";

export const Footer = () => {
  const { t } = useTranslation();
  // Footer canvas is always #171717 — on-dark type in both themes
  const { onDarkInk: ink, onDarkMuted: muted, onDarkHairline: hairline } =
    monoInk(true);

  const navLinks = [
    { name: t("nav.about"), href: "#about" },
    { name: t("nav.projects"), href: "#projects" },
    { name: t("nav.certifications"), href: "#certifications" },
    { name: t("nav.contact"), href: "#contact" },
  ];

  const socials = [
    { icon: FaGithub, label: "GitHub", href: "https://github.com/Charcrith" },
    { icon: FaLinkedin, label: "LinkedIn", href: "https://linkedin.com/in/charcrith" },
    { icon: FaEnvelope, label: "Email", href: "mailto:charcrith@gmail.com" },
  ];

  return (
    <footer id="footer" className="apple-tile apple-tile-footer !py-12 sm:!py-16">
      <div className="apple-container space-y-8 sm:space-y-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 sm:gap-6">
          <div>
            <p className="text-[12px] uppercase tracking-[0.14em] mb-2" style={{ color: muted }}>
              Portfolio
            </p>
            <h2
              className="text-[32px] sm:text-[40px] md:text-[56px] font-semibold tracking-tight leading-none"
              style={{ color: ink }}
            >
              Charcrith
            </h2>
          </div>
          <p className="text-[13px] sm:text-[14px] max-w-xs leading-relaxed" style={{ color: muted }}>
            Open to internships & collaborations in Cybersecurity and Full Stack.
          </p>
        </div>

        <div className="h-px w-full" style={{ background: hairline }} />

        <div className="grid grid-cols-2 gap-6 sm:gap-8">
          <div>
            <p className="text-[12px] font-semibold mb-3" style={{ color: ink }}>
              Navigate
            </p>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-[13px] sm:text-[14px] hover:underline" style={{ color: muted }}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[12px] font-semibold mb-3" style={{ color: ink }}>
              Connect
            </p>
            <ul className="space-y-2.5">
              {socials.map(({ icon: Icon, label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[13px] sm:text-[14px] hover:underline"
                    style={{ color: muted }}
                  >
                    <Icon className="w-3.5 h-3.5 shrink-0" />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="text-[11px] sm:text-[12px] pt-1" style={{ color: muted }}>
          © {new Date().getFullYear()} Charcrith. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
